export { default } from './Renegociacao25EmpNegocie';
